import { ConfiguratorLogApi } from "src/api/generated/erp/configurator/api/configuratorLogApi.ts";
import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType.ts";
import {
	ConfiguratorLogView,
	ConfiguratorLogViewBaseProps,
} from "src/components/views/erp/configurator/configuratorTesting/logViews/ConfiguratorLogView.tsx";

export interface ConfiguratorSessionLogViewProps extends Omit<ConfiguratorLogViewBaseProps, "fetchLogPathBase64"> {
	identifier:
		| {
				type: "sessionIdAndConfiguratorType";
				sessionId: string;
				configuratorType: PartConfiguratorType;
		  }
		| {
				type: "errorId";
				errorId: string;
		  };
}

export const ConfiguratorSessionLogView = ({ identifier, ...other }: ConfiguratorSessionLogViewProps) => {
	return (
		<ConfiguratorLogView
			fetchLogPathBase64={() => {
				switch (identifier.type) {
					case "sessionIdAndConfiguratorType":
						return ConfiguratorLogApi.getConfiguratorSessionLogFileBase64Path({
							sessionId: identifier.sessionId,
							configuratorType: identifier.configuratorType,
						});
					case "errorId":
						return ConfiguratorLogApi.getConfiguratorSessionLogFileBase64PathForError({
							errorContextId: identifier.errorId,
						});
				}
			}}
			{...other}
		/>
	);
};
